import VehiclesCreate from "../components/views/vehicle/vehicleCreates.vue";
import Vehicles from "../components/views/vehicle/vehicles.vue";

const routes = [
  {
    path: "vehicles",
    component: Vehicles,
    name: "vehicles",
    meta: {
      description: "List of Vehicles",
      title: "Vehicle",
      requiresAuth: true,
    },
  },
  {
    path: "vehicles/vehiclesCreate/:_id",
    component: VehiclesCreate,
    name: "vehiclesCreate",
    meta: {
      title: "Add / Update Vehicle",
      requiresAuth: true,
    },
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/vehicle.route.js